export const AUTH_STORE_KEY = 'app-space:auth'

export const MEMBERSHIP_STORE_KEY = 'app-space:membership'

export const USER_INFO_STORE_KEY = 'app-space:userInfo'

export const VIEW_AS_STORE_KEY = 'app-space:viewAs'

export const CREATE_PROFILE_STORAGE_KEY = 'app-space:sparkleCreateProfile'

export const TOAST_EVENT_KEY = 'app-space:toastEvent'

export const COMMUNITY_CREATION_SURVEY = 'app-space:communityCreationSurvey'

export const BIND_EXCLUSIVE_COMMUNITY_SURVEY = 'app-space:bindExclusiveCommunitySurvey'

export const IS_FIRST_ACCESS_TO_PROFILE = 'app-membership-consume:isFirstAccessToProfile'

export const REDIRECT_NEW_CLUB = 'app-club-consumer:isRedirectedUser'
